import React from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import { Typography, Button, COLORS } from 'pvs-design-system';
import { Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ROUTES } from 'constants/constants';

const ErrorPage: React.FC = () => {
  const error = useRouteError() as { statusText?: string; message?: string; status?: number } | null;
  const navigate = useNavigate();

  const is404 = error?.status === 404;
  const is403 = error?.status === 403;

  const title = is404
    ? 'Page Not Found'
    : is403
      ? 'Access Denied'
      : 'Something Went Wrong';

  const message = is404
    ? 'The page you are looking for does not exist or has been moved.'
    : is403
      ? 'You do not have permission to access this page.'
      : error?.statusText || error?.message || 'An unexpected error occurred. Please try again.';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 3,
        px: 4,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 64, color: COLORS.red[800] }} />
      <Typography variant="h1">{title}</Typography>
      <Typography
        variant="p-md"
        style={{ color: COLORS.gray[700], textAlign: 'center', maxWidth: 480 }}
      >
        {message}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(ROUTES.library)}>
          Go Back
        </Button>
        <Button variant="contained" onClick={() => navigate(ROUTES.library)}>
          Back to Library
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorPage;
